export const years: number[] = [2026, 2025, 2024, 2023, 2022];

export const yearsString: string[] = years.map((year) => year.toString());
